import ModalPortal from '@/components/ModalPortal/ModalPortal';
import type { UseFormState } from '@/hooks/useForm/interfaces';
import useFrcCaptcha from '@/hooks/useFrcCaptcha/useFrcCaptcha';
import useSubmitContactForm from '@/hooks/useSubmitContactForm/useSubmitContactForm';
import CourseRegistrationForm from '../CourseRegistrationForm/CourseRegistrationForm';
import type { CourseTimetableEvent } from '../CourseTimetable/types';
import { createCourseRegistrationSubmitFormData } from './helpers';

type CourseRegistrationFormProps = {
  categoryTitle: string;
  formApiTarget: string;
  mailTemplateId: string;
  recipientId: string;
  courseLink: string;
  title: string;
  currentEvent?: CourseTimetableEvent;
  price: string;
  id: string;
};

const CourseRegistrationFormModal = ({
  categoryTitle,
  formApiTarget,
  mailTemplateId,
  recipientId,
  courseLink,
  title,
  currentEvent,
  price,
  id,
}: CourseRegistrationFormProps) => {
  const formName = `Anmeldung - ${categoryTitle} - ${title}`;
  const { getSolution, FrcCaptchaComponent } = useFrcCaptcha();

  const {
    submitContactForm: submitRegistrationData,
    submitButtonStatus: registrationFormStatus,
  } = useSubmitContactForm({
    formName,
    recipientId,
    mailTemplateId,
    formApiTarget,
    doubleOptInActive: false,
    getCaptchaSolution: getSolution,
  });

  const handleSubmitRegistrationForm = ({ members, ...data }: UseFormState) => {
    const transformedData = createCourseRegistrationSubmitFormData({
      ...data,
      title,
      courseLink,
      categoryTitle,
      price,
      currentEvent,
      members,
    });

    return submitRegistrationData(transformedData);
  };

  return (
    <ModalPortal id={id}>
      {currentEvent && (
        <CourseRegistrationForm
          formName={formName}
          courseName={title}
          categoryName={categoryTitle}
          coursePrice={price}
          startDate={currentEvent.startDate}
          endDate={currentEvent.endDate}
          onSubmit={handleSubmitRegistrationForm}
          submitButtonStatus={registrationFormStatus}
        />
      )}
      <FrcCaptchaComponent />
    </ModalPortal>
  );
};

export default CourseRegistrationFormModal;
